module.exports = __webpack_public_path__ + "d8170d53dd17db95b4c1d4632ad83fea.pdf";